import AxiosManager from "../_axiosManager";

export async function postImgUpload(formData: any) {
    const res = await AxiosManager.getInstance().post('/admin/image', formData)

    return res
}